import React from "react";
import { Box } from "@radix-ui/themes";
import { siteLayout } from "@/constants/design/designTokens";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import "./PageLayout.css";

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  showHeader?: boolean;
  showFooter?: boolean;
  useContainer?: boolean;
  headerProps?: {
    showBackButton?: boolean;
    onBackClick?: () => void;
  };
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  className = "",
  showHeader = true,
  showFooter = true,
  useContainer = true,
  headerProps = {},
}) => {
  return (
    <div className={`page-layout ${className}`}>
      {showHeader && <Header {...headerProps} />}
      <main className="page-layout__main">
        {useContainer ? (
          <Box
            className="page-layout__content"
            style={{
              maxWidth: siteLayout.contentMaxWidth,
              margin: "0 auto",
              width: "100%",
            }}
          >
            {children}
          </Box>
        ) : (
          children
        )}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};

export default PageLayout;
